module.exports = __webpack_public_path__ + "img/goal-at-risk.49dc7af9.svg";